// pages/StepKartu.tsx
import { Card } from "@/components/ui/card";
import ProgressIndicator from "@/components/private/ProgressIndicator";
import { useUser } from "@/context/useUser";
import { useActivePeriod } from "@/hooks/useActivePeriod";
import { Loader2 } from "lucide-react";

// Import Views
import { RegularCardView } from "@/components/private/order/RegularCardView";
import { PicCardView } from "@/components/private/order/PicCardView";
import type { UserData } from "@/types/pic";

export default function StepKartu() {
    const { data: rawUser, isLoading: loadingUser } = useUser();
    const user = rawUser as UserData | null;
    const { data: activePeriod, isLoading: loadingPeriod } = useActivePeriod();

    if (loadingUser || loadingPeriod) {
        return (
            <div className="mx-auto py-12 space-y-10 pt-0 max-w-6xl">
                <Card className="border-0 shadow-lg bg-white dark:bg-gray-800 mb-3 py-12 flex flex-col items-center justify-center space-y-4">
                    <Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
                    <p className="text-slate-500 font-medium animate-pulse uppercase tracking-widest text-xs">Menyiapkan Kartu Peserta...</p>
                </Card>
            </div>
        );
    }

    if (!activePeriod || !user) return null;

    return (
        <div className="mx-auto py-12 space-y-10 pt-0 max-w-6xl animate-in fade-in duration-700">
            {/* Header Ornamen Bali */}
            <Card className="relative border-0 shadow-xl bg-white dark:bg-gray-900 mb-6 overflow-hidden rounded-3xl">
                <img src="/ornamen/ukiran-corner.png" alt="Bali" className="absolute top-0 left-0 w-40 opacity-20 pointer-events-none" />
                <img src="/ornamen/ukiran-corner.png" alt="Bali" className="absolute top-0 right-0 w-40 scale-x-[-1] opacity-20 pointer-events-none" />
                <div className="relative z-10 px-10 py-10 flex flex-col items-center text-center space-y-3">
                    <h2 className="text-xl font-black tracking-tight text-slate-900 dark:text-white uppercase">
                        {user.role_id === 3 ? "Kelola Kartu Kolektif" : "Registrasi Selesai"}
                    </h2>
                    <p className="text-xs font-medium text-slate-500 dark:text-slate-400 max-w-md">
                        {user.role_id === 3
                            ? "Unduh dan distribusikan kartu peserta untuk seluruh anggota grup Anda."
                            : "Selamat! Anda telah terdaftar secara resmi. Gunakan kartu di bawah sebagai akses masuk utama."}
                    </p>
                </div>
            </Card>

            <ProgressIndicator currentStep={5} />

            {/* View Selector */}
            <div className="mt-8">
                {user.role_id === 3 ? (
                    /* Disesuaikan: PicCardView tidak lagi menerima prop 'user' 
                       tetapi menerima 'activePeriodId' dan 'picName'
                    */
                    <PicCardView
                        activePeriodId={activePeriod.id}
                        picName={user.name}
                    />
                ) : (
                    <RegularCardView
                        user={user}
                        activePeriodId={activePeriod.id}
                    />
                )}
            </div>
        </div>
    );
}